import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
import makeSimplePage from './makeSimplePage';
import ActionBtns from './ActionBtns';
const fmt   = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '—';
const money = (v) => `₹${Number(v || 0).toLocaleString('en-IN')}`;
// ─────────────────────────────────────────────────────────────────────────────
// 13. STOCK TRANSFER PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const StockTransferPage = makeSimplePage({
  title:'Stock Transfer', subtitle:'Transfer stock between warehouses', Icon:ArrowLeftRight, color:C.purple,
  ctrl:stockTransferController, emptyTitle:'No stock transfers',
  statusOptions:['Pending','Approved','In Transit','Completed','Cancelled'],
  defaultForm:{ fromWarehouse:'',toWarehouse:'',date:new Date().toISOString().split('T')[0],items:[],totalQty:0,reason:'',requestedBy:'',status:'Pending',notes:'' },
  columns:(crud,openEdit)=>[
    { label:'Transfer No.', key:'transferNumber', render:v=><span style={{ fontFamily:'monospace', fontSize:12, color:C.purple }}>{v||'—'}</span> },
    { label:'From', key:'fromWarehouse', render:v=><div style={{ fontWeight:600 }}>{v||'—'}</div> },
    { label:'To', key:'toWarehouse', render:v=><div style={{ fontWeight:600 }}>{v||'—'}</div> },
    { label:'Date', key:'date', render:v=>fmt(v) },
    { label:'Total Qty', key:'totalQty', render:v=><Badge color={C.purple} bg={`${C.purple}12`}>{v}</Badge> },
    { label:'Reason', key:'reason', render:v=><div style={{ maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12 }}>{v||'—'}</div> },
    { label:'Status', key:'status', render:v=><StatusBadge status={v}/> },
    { label:'', key:'actions', render:(_, r)=><ActionBtns onEdit={()=>openEdit(r)} onDelete={()=>crud.handleDelete(r.id,'this transfer')} /> },
  ],
  formFields:(f,set)=>[
    <FormField key="fw" label="From Warehouse *"><input style={S.input} value={f.fromWarehouse} onChange={e=>set('fromWarehouse',e.target.value)} /></FormField>,
    <FormField key="tw" label="To Warehouse *"><input style={S.input} value={f.toWarehouse} onChange={e=>set('toWarehouse',e.target.value)} /></FormField>,
    <FormField key="dt" label="Transfer Date *"><input type="date" style={S.input} value={f.date} onChange={e=>set('date',e.target.value)} /></FormField>,
    <FormField key="tq" label="Total Qty"><input type="number" style={S.input} value={f.totalQty} onChange={e=>set('totalQty',e.target.value)} /></FormField>,
    <FormField key="rb" label="Requested By"><input style={S.input} value={f.requestedBy} onChange={e=>set('requestedBy',e.target.value)} /></FormField>,
    <FormField key="st" label="Status"><select style={S.select} value={f.status} onChange={e=>set('status',e.target.value)}>{['Pending','Approved','In Transit','Completed','Cancelled'].map(s=><option key={s}>{s}</option>)}</select></FormField>,
    <FormField key="re" label="Reason" col={2}><input style={S.input} value={f.reason} onChange={e=>set('reason',e.target.value)} /></FormField>,
    <FormField key="no" label="Notes" col={2}><textarea style={{ ...S.textarea, minHeight:60 }} value={f.notes} onChange={e=>set('notes',e.target.value)} /></FormField>,
  ],
});

export default StockTransferPage;
